import * as ActionTypes from "../ActionTypes.js";

export const lostReducer = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.GET_LOST:
      return action.payload;
    case ActionTypes.ADD_LOST:
      var newLost = action.payload;
      return [...state, newLost];
    case ActionTypes.DELETE_LOST:
      return state.filter((item) => item.id !== action.payload);
    case ActionTypes.RESOLVE_LOST:
      return state.filter((item) => item.id !== action.payload);
    default:
      return state;
  }
};
